export default "__VITE_ASSET__CBYmHZAn__"